import { selectCarYear } from "./selectCarYear";

export const selectCar = (state) => {
  return {
    ...state.car,
    year: selectCarYear(state)
  }
};
